import React from 'react';

const InvoiceSummary = ({ filtersDetails, loading }) => {
  return filtersDetails && filtersDetails?.data?.length && !loading ? (
    <div className='w-full md:w-[400px]'>
      <div className=' bg-white rounded px-4 py-2 mt-4 border'>
        <div className='text-md flex justify-between py-2 border-b'>
          <span className='font-semibold'>Total Amount With Tax:</span>{' '}
          <span>{filtersDetails?.total_amount?.toFixed(2) || '0'} SAR</span>
        </div>
        <div className='text-md flex justify-between py-2 border-b'>
          <span className='font-semibold'>Total Amount Without Tax:</span>{' '}
          <span>{filtersDetails?.total_amount_no_tax?.toFixed(2) || '0'} SAR</span>
        </div>
        <div className='text-md flex justify-between py-2 border-b'>
          <span className='font-semibold'>Total Tax:</span>{' '}
          <span>{filtersDetails?.total_tax_amount?.toFixed(2) || '0'} SAR</span>
        </div>
        <div className='text-md flex justify-between py-2 border-b'>
          <span className='font-semibold'>Total Pages:</span> <span>{filtersDetails?.total_pages}</span>
        </div>
        <div className='text-md flex justify-between py-2'>
          <span className='font-semibold'>Total Records:</span> <span>{filtersDetails?.total_record}</span>
        </div>
      </div>
    </div>
  ) : (
    ''
  );
};

export default InvoiceSummary;
